const Header = () => {
  return (
    <div className="relative w-full flex flex-wrap items-center justify-center py-6 px-4 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 shadow-lg">
      <div className="container-fluid">
        <div className="flex flex-col gap-2 items-center justify-center text-white font-bold">
          <span className="text-3xl xxs:text-4xl">DropTrak</span> 
          <span className="xxs:text-2xl">Issue Tracker Module</span>
        </div>
      </div> 
    </div>
    
  )
}
export default Header

